import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class TitleService {  
    constructor() {}

    originalTitle:string = null

    init() {
        this.originalTitle = document.querySelector('head title')?.innerHTML
    }

    setTitle(title?:string) {
        if(!title) {
            title = this.originalTitle
        }

        document.querySelector('head title').innerHTML = title
    }
}